module.exports = __webpack_public_path__ + "static/img/2.edee101d.png";